import React from 'react';

const AppleIcon = ({ size = 89, fill = 'var(--icon-color, #3EAB36)' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 89 89"
    fill="none"
  >
    <path
      style={{transition: '0.7s ease-in-out'}}
      d="M63.2271 75.205C59.593 78.7279 55.625 78.1717 51.8055 76.5029C47.7634 74.7971 44.055 74.7229 39.7905 76.5029C34.4505 78.8021 31.6321 78.1346 28.443 75.205C10.3463 56.5521 13.0163 28.1462 33.5605 27.1079C38.5667 27.3675 42.0525 29.8521 44.9821 30.0746C49.358 29.1846 53.5484 26.6258 58.2209 26.9596C63.8205 27.4046 68.048 29.6296 70.8292 33.6346C59.2592 40.5692 62.0034 55.8104 72.6092 60.075C70.4955 65.6375 67.7513 71.1629 63.19 75.2421L63.2271 75.205ZM44.6113 26.8854C44.055 18.6158 50.7671 11.7925 58.4805 11.125C59.5559 20.6925 49.803 27.8125 44.6113 26.8854Z"
      fill={fill}
    />
  </svg>
);

export default AppleIcon;
